import { getLocalStorageValue } from "@xompass/web-sdk";
import { io, Socket } from "socket.io-client";
import msgpackParser from "socket.io-msgpack-parser";

function getRealtimeUrl(rtPath: string) {
  if (rtPath.startsWith("/")) {
    const url = new URL(rtPath, window.location.origin);
    if (url.pathname === "/") {
      return url.origin;
    }
    return url.toString().replace(/\/$/, "");
  }

  return rtPath.replace(/\/$/, "");
}

export const getSocket = (): Socket | null => {
  const rtPath = import.meta.env.VITE_RTPATH;
  if (!rtPath) {
    return null;
  }

  return io(getRealtimeUrl(rtPath), {
    autoConnect: false,
    parser: msgpackParser,
    auth: (cb) => {
      const accessToken = getLocalStorageValue("vsaas$accessToken");
      cb(accessToken ? { access_token: accessToken } : {});
    },
    transports: ["websocket"],
    reconnection: true,
    reconnectionDelay: 3000,
    reconnectionDelayMax: 10000,
    reconnectionAttempts: Infinity,
    timeout: 20000,
  });
};
